(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_collection_info_tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".custom-collection_tab-button");
  const tabContents = document.querySelectorAll(".custom-collection_tab-content");

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      document.querySelector(".custom-collection_tab-button.active")?.classList.remove("active");
      document.querySelector(".custom-collection_tab-content.active")?.classList.remove("active");

      button.classList.add("active");
      const tabId = button.getAttribute("data-tab");
      document.getElementById(tabId)?.classList.add("active");
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_quality_slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const content = document.querySelector('.custom_quality_slider_content');
    const boxes = document.querySelectorAll('.custom_quality_slider_box');
    const prevBtn = document.querySelector('.slider-nav.prev');
    const nextBtn = document.querySelector('.slider-nav.next');

    const visibleCount = () => window.innerWidth < 768 ? 1 : 3;
    const boxWidth = () => {
      const box = boxes[0];
      const style = getComputedStyle(box);
      return box.offsetWidth + parseFloat(style.marginRight);
    };

    let currentIndex = 0;
    let totalBoxes = boxes.length;

    function slideTo(index, smooth = true) {
      const offset = index * boxWidth();
      content.style.transition = smooth ? 'transform 0.4s ease' : 'none';
      content.style.transform = `translateX(-${offset}px)`;
    }

    nextBtn.addEventListener('click', () => {
      currentIndex++;
      slideTo(currentIndex);

      const maxIndex = totalBoxes - visibleCount();
      if (currentIndex >= maxIndex) {
        setTimeout(() => {
          currentIndex = 0;
          slideTo(currentIndex, false);
        }, 400);
      }
    });

    prevBtn.addEventListener('click', () => {
      if (currentIndex === 0) {
        currentIndex = totalBoxes - visibleCount();
        slideTo(currentIndex, false);
        setTimeout(() => {
          currentIndex--;
          slideTo(currentIndex);
        }, 20);
      } else {
        currentIndex--;
        slideTo(currentIndex);
      }
    });

    window.addEventListener('resize', () => {
      slideTo(currentIndex, false);
    });

    // === Touch / Swipe Support Mobil ===
    let startX = 0;
    let isTouching = false;

    content.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isTouching = true;
    });

    content.addEventListener('touchmove', (e) => {
      if (!isTouching) return;
      const diffX = e.touches[0].clientX - startX;

      if (Math.abs(diffX) > 50) {
        if (diffX < 0) {
          nextBtn.click();
        } else {
          prevBtn.click();
        }
        isTouching = false;
      }
    });

    content.addEventListener('touchend', () => {
      isTouching = false;
    });

    slideTo(currentIndex);
  });

  } catch(e) { console.error(e); }
})();
})();
